import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { isDarkTheme as isDarkThemeSelector } from "@multiweb/reactCore/theme";
import { IconCode } from "@multiweb/types/contracts";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { USER_MENU_TOGGLE_THEME_ITEM_ID } from "../../constants";
import { LOC_KEY_THEME_DARK, LOC_KEY_THEME_LIGHT } from "../../locKeys";
import { isItemFocused, MenuFocusableItemType, MenuNavigationSectionType } from "../../navigation";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createMenuItemMouseActivationHandler } from "../../utils";
import { MenuItemComponent, MenuItemComponentProps } from "../MenuItemComponent";
import { MenuItemComponentVariant } from "../MenuItemComponent/types";

type StateProps = Pick<MenuItemComponentProps, "label" | "isFocused">;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => {
    const isDarkTheme = isDarkThemeSelector(state);
    return {
        label: getPrimaryText(state, isDarkTheme ? LOC_KEY_THEME_LIGHT : LOC_KEY_THEME_DARK),
        iconCode: isDarkTheme ? IconCode.weatherSun : IconCode.weatherMoon,
        isFocused: isItemFocused(state, { itemId: USER_MENU_TOGGLE_THEME_ITEM_ID, type: MenuFocusableItemType.userMenuItem, section: MenuNavigationSectionType.static }),
    };
};

type DispatchProps = {
    buttonActivated: typeof createMenuItemActivatedAction;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = {
    buttonActivated: createMenuItemActivatedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, NoneOwnProps, MenuItemComponentProps> = (stateProps, { buttonActivated }) => ({
    ...stateProps,
    variant: MenuItemComponentVariant.usermenu,
    onClick: createMenuItemMouseActivationHandler(USER_MENU_TOGGLE_THEME_ITEM_ID, MenuItemActivatedType.toggleThemeButton, MenuNavigationSectionType.static, buttonActivated),
    onKeyUp: createMenuItemKeyActivationHandler(USER_MENU_TOGGLE_THEME_ITEM_ID, MenuItemActivatedType.toggleThemeButton, MenuNavigationSectionType.static, buttonActivated),
});

export const ToggleThemeButton = connect(mapStateToProps, mapDispatchToProps, mergeProps)(MenuItemComponent);
